import React from 'react';

export const SourceDeleted = ({
  className,
  color,
}: {
  className?: string;
  color?: string;
}) => (
<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.5393 19.6249L9.8333 10.9179H5.2473V8.91794H7.8333L5.8333 6.91794H5.2473C4.45165 6.91794 3.68858 7.23401 3.12598 7.79662C2.56337 8.35923 2.2473 9.12229 2.2473 9.91794C2.2473 10.7136 2.56337 11.4766 3.12598 12.0393C3.68858 12.6019 4.45165 12.9179 5.2473 12.9179H8.2473V14.9179H5.2473C4.03005 14.9189 2.85425 14.4759 1.94038 13.6718C1.0265 12.8677 0.43733 11.7579 0.283345 10.5505C0.12936 9.34299 0.421138 8.12082 1.10396 7.11314C1.78679 6.10545 2.81376 5.38146 3.9923 5.07694L0.539296 1.62494L1.9543 0.210938L19.9543 18.2109L18.5403 19.6239V19.6249H18.5393ZM18.3833 13.8109L16.9553 12.3839C17.4808 12.0199 17.8762 11.4975 18.084 10.893C18.2917 10.2884 18.301 9.63333 18.1103 9.02317C17.9196 8.41302 17.5391 7.87972 17.0241 7.50102C16.5091 7.12232 15.8865 6.91804 15.2473 6.91794H12.2473V4.91794H15.2473C16.2818 4.91806 17.2907 5.23905 18.1351 5.83666C18.9795 6.43427 19.6178 7.27908 19.9619 8.25464C20.3061 9.2302 20.3391 10.2885 20.0566 11.2836C19.774 12.2788 19.1897 13.1618 18.3843 13.8109H18.3833Z" fill="#FF7452"/>
</svg>

);
